import React from "react";

const MspAccountsBanner = ({ bannerData }) => {
  return (
    <>
      <div className="p-5" />
      <div className="sub-usage-container d-flex m-0 radius-8 bg-grey">
        <div className="left-container p-0 w-100">
          <div className="item p-3">
            <div className="f-500 f-grey">MSP's Accounts</div>
            <div className="f-18 f-500 f-black mt-2 mb-3">{bannerData?.stats?.OverAll} </div>
          </div>
          <div className="item p-3">
            <div className="f-500 f-grey">Trials expired</div>
            <div className="f-18 f-500 f-black mt-2 mb-3">{bannerData?.stats?.TrialExpired}</div>
          </div>
          <div className="item p-3">
            <div className="f-500 f-grey">On Trial Period</div>
            <div className="f-18 f-500 f-black mt-2 mb-3">{bannerData?.stats?.OnTrial}</div>
          </div>
          <div className="item p-3">
            <div className="f-500 f-grey">On Paid Suscription</div>
            <div className="f-18 f-500 f-black mt-2 mb-3">{bannerData?.stats?.Paid}</div>
          </div>
        </div>
        <div className="p-3 subscription-usage-wrapper w-100">
          <div className="f-grey f-500 mb-3">Subscriptions Usage</div>
          {bannerData?.plans
            ?.sort((a, b) => a.Order - b.Order)
            ?.map((item, index) => {
              const maxValue =
                bannerData?.plans?.length > 0
                  ? Math.max(...bannerData?.plans?.map((item) => item.Value))
                  : 0;
              return (
                <div key={index} className="w-100">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center f-grey">
                      <img
                        src="/images/msp/dollar-icon.svg"
                        alt=""
                        className="mr-2"
                        width={13}
                        height={13}
                      />
                      {item.Label}
                    </div>
                    <div className="f-darkgrey">{item?.Value} </div>
                  </div>
                  <div className="w-100">
                    <progress value={item.Value} max={maxValue} />
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default MspAccountsBanner;

